import React,{useState} from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import './client-form.css';

const {FiGripVertical,FiPlus,FiTrash2}=FiIcons;

const defaultQuestions=[
  'Favorite T.V. show?',
  'Favorite Movie?',
  'Favorite Color?',
  'Favorite musical group?',
  'Favorite type of music?',
  'Favorite food?',
  'School subject?',
  'Favorite Designer',
  'Favorite Website',
  'Favorite sport?',
  'Favorite car?',
  'Favorite recreational activity?'
];

function createQuestion(question='',answer='') {
  return {
    id: `trivia-${Date.now()}-${Math.random().toString(36).slice(2)}`,
    question,
    answer
  };
}

function getInitialQuestions(otherDetails) {
  if (otherDetails && typeof otherDetails==='object') {
    if (Array.isArray(otherDetails.questions)) {
      return otherDetails.questions.map((item)=> ({
        id: item.id || createQuestion().id,
        question: item.question || '',
        answer: item.answer || ''
      }));
    }

    const savedAnswers=otherDetails.trivia || {};
    const customQuestions=Array.isArray(otherDetails.customQuestions)
      ? otherDetails.customQuestions
      : [];

    return [
      ...defaultQuestions.map((question)=> createQuestion(
        question,
        savedAnswers[question] || ''
      )),
      ...customQuestions.map((item)=> createQuestion(
        item.question || '',
        item.answer || ''
      ))
    ];
  }

  return defaultQuestions.map((question)=> createQuestion(question));
}

function TriviaQuestions({otherDetails,onChange}) {
  const [questions,setQuestions]=useState(
    ()=> getInitialQuestions(otherDetails)
  );
  const [draggedIndex,setDraggedIndex]=useState(null);

  const saveQuestions=(nextQuestions)=>{
    setQuestions(nextQuestions);
    onChange({questions: nextQuestions});
  };

  const updateQuestion=(index,key,value)=>{
    const nextQuestions=questions.map((item,itemIndex)=> (
      itemIndex===index ? {...item,[key]: value} : item
    ));

    saveQuestions(nextQuestions);
  };

  const addQuestion=()=>{
    saveQuestions([...questions,createQuestion('', '')]);
  };

  const removeQuestion=(index)=>{
    saveQuestions(questions.filter((_,itemIndex)=> itemIndex!==index));
  };

  const dropQuestion=(targetIndex)=>{
    if (draggedIndex===null || draggedIndex===targetIndex) {
      setDraggedIndex(null);
      return;
    }

    const nextQuestions=[...questions];
    const [movedQuestion]=nextQuestions.splice(draggedIndex,1);
    nextQuestions.splice(targetIndex,0,movedQuestion);
    saveQuestions(nextQuestions);
    setDraggedIndex(null);
  };

  return (
    <div className="trivia-table-card">
      <div className="trivia-table-heading">
        <div>
          <strong>Trivia Questions</strong>
          <span>Customize the guest of honor’s favorites.</span>
        </div>
        <button
          type="button"
          className="button secondary trivia-add-button"
          onClick={addQuestion}
        >
          <SafeIcon icon={FiPlus} />
          Add question
        </button>
      </div>

      {questions.length===0 ? (
        <div className="trivia-empty">
          <strong>No trivia questions</strong>
          <span>Add a question to get started.</span>
        </div>
      ) : (
        <div className="trivia-question-list">
          {questions.map((item,index)=> (
            <div
              className={
                draggedIndex===index
                  ? 'trivia-question-row dragging'
                  : 'trivia-question-row'
              }
              key={item.id}
              draggable
              onDragStart={()=> setDraggedIndex(index)}
              onDragOver={(event)=> event.preventDefault()}
              onDrop={()=> dropQuestion(index)}
              onDragEnd={()=> setDraggedIndex(null)}
            >
              <span
                className="trivia-drag-handle"
                title="Drag to reorder"
                aria-label={`Drag trivia question ${index+1}`}
              >
                <SafeIcon icon={FiGripVertical} />
              </span>

              <input
                value={item.question}
                onChange={(event)=> updateQuestion(
                  index,
                  'question',
                  event.target.value
                )}
                placeholder={`Question ${index+1}`}
                aria-label={`Trivia question ${index+1}`}
              />

              <input
                value={item.answer}
                onChange={(event)=> updateQuestion(
                  index,
                  'answer',
                  event.target.value
                )}
                placeholder="Enter answer"
                aria-label={`Answer for trivia question ${index+1}`}
              />

              <button
                type="button"
                className="icon-btn danger"
                onClick={()=> removeQuestion(index)}
                aria-label={`Remove trivia question ${index+1}`}
                title="Remove question"
              >
                <SafeIcon icon={FiTrash2} />
              </button>
            </div>
          ))}
        </div>
      )}

      <p className="trivia-add-hint">
        Drag questions to change their order.
      </p>
    </div>
  );
}

export default TriviaQuestions;